/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @version 1.0.0
 * @since 1.0.0
 */

import { isValidElement, FC, RefObject } from 'react';

import isArray from 'lodash/isArray';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';

import { fonts } from '../../../theme';
import { TextContainerStyled } from './styled/TextBlockStyled';

export interface IStyledProps {
    className?: string;
    defaultColor?: string;
    defaultValue?: string;
    font?: string;
    innerHtml?: string;
    onClick?: () => void;
    style?: {[key: string]: string};
    textRef?: RefObject<HTMLSpanElement>;
}

/**
 * @deprecated
 */
const TextBlock: FC<IStyledProps> = (props) => {
    const textBlockFont = props.font ? props.font : fonts.textMain;
    const value = props.children
    && (
        isValidElement(props.children)
        || isNumber(props.children)
        || isString(props.children)
        || isArray(props.children)
    )
        ? props.children
        : props.defaultValue ? props.defaultValue : '';
    return (
        <TextContainerStyled
            { ...{ ...props, ...{ font: textBlockFont } } }
            ref={props.textRef}
        >
            {props.innerHtml ? <div dangerouslySetInnerHTML={{ __html: props.innerHtml }}/> : value}
        </TextContainerStyled>
    );
};

export default TextBlock;
